enum SocialNetworkType {
  reddit = 'reddit',
  discord = 'discord',
  instagram = 'instagram',
  facebook = 'facebook',
  twitter = 'twitter',
  tiktok = 'tiktok',
}

export interface Testimonial {
  id: number;
  body: string;
  socialNickToDisplay: string;
  socialNick: string;
  socialNetworkLink: URL;
  displateLink: URL;
  socialType: SocialNetworkType;
}

export const testimonialsData: Testimonial[] = [
  {
    id: 1,
    body: 'My new @starwars @Displate look amazing on my office wall!!',
    socialNickToDisplay: 'John Schrier',
    socialNick: '@FatGreenDragon',
    socialNetworkLink: new URL('https://twitter.com/FatGreenDragon/status/1666906457806102540'),
    displateLink: new URL('https://displate.com/star_wars/star-wars-movie-posters'),
    socialType: SocialNetworkType.twitter,
  },
  {
    id: 2,
    body: 'These posters made our remodeled basement what it is. High quality, amazing products.',
    socialNickToDisplay: 'TattyBooJangles',
    socialNick: '@TattyBooJangles',
    socialNetworkLink: new URL(
      'https://twitter.com/tattyboojangles/status/1642952421646188545?s=46&t=iaiFb2m3gPfWoppQ25FVrA',
    ),
    displateLink: new URL('https://displate.com/displate/6223301'),
    socialType: SocialNetworkType.twitter,
  },
  {
    id: 3,
    body: 'Those Displate posters are awesome!\n Great quality, easy to install and fair prices!',
    socialNickToDisplay: 'Sagittarius Artworks',
    socialNick: '@SagittariusArt',
    socialNetworkLink: new URL('https://twitter.com/SagittariusArt/status/1614937920518987779'),
    displateLink: new URL('https://displate.com/displate/5947693'),
    socialType: SocialNetworkType.twitter,
  },
  {
    id: 4,
    body: 'I absolutely love it… look how badass geralt looks !',
    socialNickToDisplay: 'Joe Zaccardelli',
    socialNick: '@joe_zaccardelli',
    socialNetworkLink: new URL('https://twitter.com/joe_zaccardelli/status/1446446650864685057'),
    displateLink: new URL('https://displate.com/limited-edition/displate/5026103'),
    socialType: SocialNetworkType.twitter,
  },
  {
    id: 5,
    body: 'The detail is crazy Displate Worth every penny!',
    socialNickToDisplay: 'G1',
    socialNick: '- ',
    socialNetworkLink: new URL(
      'https://www.facebook.com/dannyg1garcia/posts/pfbid02bpAPGiiz4pQvnHA2joTsT1iqrUtEYKK42HUSaZ9mDsBe8w1DSw39AhDH8Ese151Jl',
    ),
    displateLink: new URL('https://displate.com/limited-edition/displate/6486185'),
    socialType: SocialNetworkType.facebook,
  },
  {
    id: 6,
    body: 'Very impressed with the quality and easy to mount them',
    socialNickToDisplay: 'Yaakov Fein ✡️',
    socialNick: '@frumfitness',
    socialNetworkLink: new URL('https://twitter.com/frumfitness/status/1675461679545475073'),
    displateLink: new URL('https://displate.com/displate/6529973?ref=1617'),
    socialType: SocialNetworkType.twitter,
  },
  {
    id: 8,
    body: 'wow its absolutely stunning. Looks great on the wall. Cant wait for more...',
    socialNickToDisplay: 'LittlebitofMadness',
    socialNick: '@LBOMadness',
    socialNetworkLink: new URL('https://twitter.com/LBOMadness/status/1491370467978285057'),
    displateLink: new URL('https://displate.com/displate/296952'),
    socialType: SocialNetworkType.twitter,
  },
  {
    id: 9,
    body: 'Actually, I LOVE my Displates!!!',
    socialNickToDisplay: 'Lou Mongello',
    socialNick: '@LouMongello',
    socialNetworkLink: new URL(
      'https://twitter.com/loumongello/status/1574463976959873025?s=46&t=iaiFb2m3gPfWoppQ25FVrA',
    ),
    displateLink: new URL('https://displate.com/licensed/dc-comics'),
    socialType: SocialNetworkType.twitter,
  },
  {
    id: 11,
    body: 'These are magnetic metal art panels from #displate and they are awesome!',
    socialNickToDisplay: 'Zenith',
    socialNick: '@Above_Z',
    socialNetworkLink: new URL('https://twitter.com/Above_Z/status/1486057342139613185'),
    displateLink: new URL('https://displate.com/doa/solar-system'),
    socialType: SocialNetworkType.twitter,
  },
  {
    id: 12,
    body: 'I am very happy with this Displate. In terms of color, it fits best with Gamma Ray Ghouls.',
    socialNickToDisplay: 'Percilator',
    socialNick: '@u/Percilator',
    socialNetworkLink: new URL(
      'https://www.reddit.com/r/Displate/comments/11bgw4h/souls_of_the_future_fits_perfectly_with_my/',
    ),
    displateLink: new URL('https://displate.com/limited-edition/displate/4153053'),
    socialType: SocialNetworkType.reddit,
  },
];
